/* ==========================================
   POPUP - SOU DE ALGODÃO
========================================== */

(() => {

    const POPUP_SELECTOR =
        '#popup-selo-algodao';


    /* ==========================================
       ABRIR POPUP
       FUNCIONA NOS 2 FORMATOS DE SELO
    ========================================== */

    document.addEventListener(
        'click',
        e => {

            const trigger =
                e.target.closest(
                    '.algodao-banner--card, .algodao-banner-horizontal'
                );

            if (!trigger)
                return;


            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();


            const popup =
                document.querySelector(
                    POPUP_SELECTOR
                );

            if (!popup)
                return;


            popup.classList.add(
                'is-open'
            );


            document.body.style.overflow =
                'hidden';

        },
        true
    );


    /* ==========================================
       FECHAR NO X OU BOTÃO
    ========================================== */

    document.addEventListener(
        'click',
        e => {

            const close =
                e.target.closest(
                    '[data-close-selo-algodao]'
                );

            if (!close)
                return;


            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();


            closePopup();

        },
        true
    );


    /* ==========================================
       FECHAR CLICANDO FORA
    ========================================== */

    document.addEventListener(
        'click',
        e => {

            const popup =
                document.querySelector(
                    POPUP_SELECTOR
                );

            if (
                !popup ||
                !popup.classList.contains(
                    'is-open'
                )
            ) {
                return;
            }


            if (
                e.target === popup
            ) {

                closePopup();

            }

        }
    );


    /* ==========================================
       FECHAR COM ESC
    ========================================== */

    document.addEventListener(
        'keydown',
        e => {

            if (
                e.key !== 'Escape'
            ) {
                return;
            }


            closePopup();

        }
    );


    /* ==========================================
       FUNÇÃO FECHAR
    ========================================== */

    function closePopup() {

        const popup =
            document.querySelector(
                POPUP_SELECTOR
            );

        if (!popup)
            return;


        popup.classList.remove(
            'is-open'
        );


        document.body.style.overflow =
            '';

    }

})();